import React from 'react';
import LineContainer from '../containers/LineContainer';
import NavLinkToggle from './NavLinkToggle';
import { NavLink } from 'react-router-dom';

const sectionStyles = {
  verse: {},
  chorus: {
    fontWeight: 700,
  },
  bridge: {
    fontStyle: 'italic',
  },
};

export default function Section(props) {
  return (
    <div className=" py-3 border-bottom" key={props.id} style={sectionStyles[props.section.type]}>
      {props.ui.toggles.ids && <span className="id id-left text-muted">{props.id}</span>}

      <NavLink
        to={`/song/${props.sectionIndex}`}
        className="selectable d-block"
        activeClassName="selected"
        location={props.location}
        exact
      >
        <div className="d-flex w-100 justify-content-between">
          <h5 className="m-0">
            {props.section.label ||
              props.section.type || <span className="text-muted">Section</span>}
          </h5>
          {(props.ui.toggles.stresses || props.ui.toggles.syllables) && (
            <small>
              {props.ui.toggles.syllables && (
                <span className="small line-syllables">Syllables</span>
              )}
              {props.ui.toggles.stresses && props.ui.toggles.syllables && ' / '}
              {props.ui.toggles.stresses && <span className="small line-syllables">Stresses</span>}
            </small>
          )}
        </div>
      </NavLink>
      {props.lines.map((line, index) => (
        <NavLinkToggle
          to={`/song/${props.sectionIndex}/${index}`}
          className="d-block selectable"
          activeClassName="selected"
          key={line.id}
          location={props.location}
        >
          <LineContainer
            line={line}
            // id={line.id}
            // allLineGroups={props.allLineGroups}
            // allLines={props.allLines}
            onReplace={props.onReplaceLine && (newLineId => props.onReplaceLine(index, newLineId))}
            lineIndex={index}
          />
        </NavLinkToggle>
      ))}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Section.js